export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    /* eslint-disable */

    $(document).ready(function(){


        // Google Map on locations
        (function($) {

          /**
           * centerMap
           *
           * Centers the map showing all markers in view.
           *
           * @date    22/10/19
           * @since   5.8.6
           *
           * @param   object The map instance.
           * @return  void
           */
          function centerMap( map ) {

              // Create map boundaries from all map markers.
              var bounds = new google.maps.LatLngBounds();
              map.markers.forEach(function( marker ){
                  bounds.extend({
                      lat: marker.position.lat(),
                      lng: marker.position.lng()
                  });
              });

              // Case: Single marker.
              if( map.markers.length === 1 ){
                  map.setCenter( bounds.getCenter() );

              // Case: Multiple markers.
              } else{
                  map.fitBounds( bounds );
              }
          }
          /**
           * initMap
           *
           * Renders a Google Map onto the selected jQuery element
           *
           * @date    22/10/19
           * @since   5.8.6
           *
           * @param   jQuery $el The jQuery element.
           * @return  object The map instance.
           */
          function initMap( $el ) {

              // Find marker elements within map.
              var $markers = $el.find('.marker');

              // Create gerenic map.
              var mapArgs = {
                  zoom        : $el.data('zoom') || 13,
                  mapTypeId   : google.maps.MapTypeId.ROADMAP,
                  styles : [
                              {
                                  "featureType": "water",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "color": "#d3d3d3"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "transit",
                                  "stylers": [
                                      {
                                          "color": "#808080"
                                      },
                                      {
                                          "visibility": "off"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.highway",
                                  "elementType": "geometry.stroke",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      },
                                      {
                                          "color": "#b3b3b3"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.highway",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "color": "#ffffff"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.local",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      },
                                      {
                                          "color": "#ffffff"
                                      },
                                      {
                                          "weight": 1.8
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.local",
                                  "elementType": "geometry.stroke",
                                  "stylers": [
                                      {
                                          "color": "#d7d7d7"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "poi",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      },
                                      {
                                          "color": "#ebebeb"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "administrative",
                                  "elementType": "geometry",
                                  "stylers": [
                                      {
                                          "color": "#a7a7a7"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.arterial",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "color": "#ffffff"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.arterial",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "color": "#ffffff"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "landscape",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      },
                                      {
                                          "color": "#efefef"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road",
                                  "elementType": "labels.text.fill",
                                  "stylers": [
                                      {
                                          "color": "#696969"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "administrative",
                                  "elementType": "labels.text.fill",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      },
                                      {
                                          "color": "#737373"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "poi",
                                  "elementType": "labels.icon",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "poi",
                                  "elementType": "labels",
                                  "stylers": [
                                      {
                                          "visibility": "on"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road.arterial",
                                  "elementType": "geometry.stroke",
                                  "stylers": [
                                      {
                                          "color": "#d6d6d6"
                                      }
                                  ]
                              },
                              {
                                  "featureType": "road",
                                  "elementType": "labels.icon",
                                  "stylers": [
                                      {
                                          "visibility": "off"
                                      }
                                  ]
                              },
                              {},
                              {
                                  "featureType": "poi",
                                  "elementType": "geometry.fill",
                                  "stylers": [
                                      {
                                          "color": "#dadada"
                                      }
                                  ]
                              }
                          ]
              };
              var map = new google.maps.Map( $el[0], mapArgs );

              // Add markers.
              map.markers = [];
              $markers.each(function(){
                  initMarker( $(this), map );
              });

              // Center map based on markers.
              centerMap( map );

              // Return map instance.
              return map;
          }
          /**
           * initMarker
           *
           * Creates a marker for the given jQuery element and map.
           *
           * @date    22/10/19
           * @since   5.8.6
           *
           * @param   jQuery $el The jQuery element.
           * @param   object The map instance.
           * @return  object The marker instance.
           */
          function initMarker( $marker, map ) {

              // Get position from marker.
              var lat = $marker.data('lat');
              var lng = $marker.data('lng');
              var latLng = {
                  lat: parseFloat( lat ),
                  lng: parseFloat( lng )
              };

              var icon = {
                  path: "M31.6,28.4c2.3-3,3.7-6.7,3.7-10.7C35.3,7.9,27.4,0,17.7,0C7.9,0,0,7.9,0,17.6c0,4,1.4,7.7,3.6,10.7l14,20.5L31.6,28.4z",
                  fillColor: '#45b0e4',
                  fillOpacity: 1,
                  anchor: new google.maps.Point(16,45),
                  strokeWeight: 0,
                  scale: 1
              };

              // create a marker with our custom icon
              var marker = new google.maps.Marker({
                position: latLng,
                map: map,
                // icon: '/app/themes/burnleyleisure/map-markers/map-marker.svg',
                icon: icon,
                size: new google.maps.Size(32,45),
              });

              // Append to reference for later use.
              map.markers.push( marker );

              // If marker contains HTML, add it to an infoWindow.
              if( $marker.html() ){

                  // Create info window.
                  var infowindow = new google.maps.InfoWindow({
                      content: $marker.html()
                  });

                  // Show info window when marker is clicked.
                  google.maps.event.addListener(marker, 'click', function() {
                      infowindow.open( map, marker );
                  });
              }
          }

          // Render the map on page load
          $(document).ready(function(){
              $('.acf-map').each(function(){
                  var map = initMap( $(this) );
              });
          });

        })(jQuery);



    });

    /* eslint-enable */

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/contact.js